/*
 * @Descripttion: 去重
 * @Author: yang chenglin
 */

import { lazy } from 'ice';
import UUID from '@/utils/UUID';
import iconImage from '@/assets/images/CanvasImages/duplicate-remove.svg';
import Form from './Form';
import Info from './Info';

export default {
  info: {
    icon: 'icon-iconlujingyunsuan-07',
    // iconText: '&#xe66f;',
    iconText: iconImage,
    name: 'CROWD_DIFFERENCES',
    label: '去重',
    //输入类型： 0-无 1-人群包 2-人群包列表
    inputType: 1, //输入人群包
    minInputCount: 2, //最小输入数量2
    maxInputCount: 99, //最大输入数量99
    //输出类型： 0-可选 1-人群包 2-人群包列表
    outputType: 2, //输出人群包列表
    minOutputCount: 1, //最小输出数量1
    maxOutputCount: 99, //最大输出数量99
    desc: '去掉两个及以上人群重复部分的人群'
  },
  data: () => ({
    name: `去重 ${UUID.getNowTime()}`,
    type: 0, // 去重方式：0-连线顺序去重 1-升序去重 2-降序去重
    crowdNames: [], // 人群优先级数组
    remark: '',
  }),

  validators: {
    name: (val, allNodeData = [], currentNode = {}, getAllNodes = []) => new Promise((resolve, reject) => {
      //allNodeData是点击menu上各种操作的按钮操作之后的节点数据，getAllNodes是从画布上直接得到的所有现有节点的id，
      //当通过按钮删除节点的时候走前者，allNodeData是删除后的数据，但当不通过删除组件按钮删除节点，而是通过键盘Del键时，
      //是直接走的画布上的键盘监听方法，改变不了allNodeData，因此此处判断节点名称是否重复的时候，要计算一下
      //例如：画布上现有节点id[1,2,3]，键盘Del键删掉3之后，allNodeData仍然是[1,2,3]，而getAllNodes是[1,2]
      allNodeData.forEach((item, index) => {
        if(!getAllNodes.includes(item.nodeId)){
          allNodeData.splice(index, 1)
        }
      })
      try {
        if (val === '') {
          reject(new Error('节点名称不能为空'));
        } else if (allNodeData.filter((item) => { if (item.data.name === val && item.nodeId !== currentNode.nodeId) return item }).length >= 1) {
          reject(new Error('节点名称不能与其他节点重复'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    crowdNames: (val) => new Promise((resolve, reject) => {
      try {
        if (val.length === 0) {
          reject(new Error('人群优先级列表不能为空'));
        } else {
          resolve();
        }
      } catch (error) {
        throw error;
      }
    }),
    // remark: (val) => new Promise((resolve, reject) => {
    //   try {
    //     if (val === '') {
    //       reject(new Error('备注不能为空'));
    //     } else {
    //       resolve();
    //     }
    //   } catch (error) {
    //     throw error;
    //   }
    // }),
  } ,
  components: {
    // Form: lazy(() => import('./Form')),
    // Info: lazy(() => import('./Info')),
    Form: Form,
    Info: Info,
  }
}
